module.exports = __webpack_public_path__ + "img/ro.50cf1617.svg";